<app-media-page
  [loading]="loading"
  [medias]="medias$ | async"
  [hasNextPage]="hasNextPage"
  title="Le contenus que j'aime"
  color="red"
></app-media-page>
